import React from 'react'
import '../Styles/home.css'
import logo from '../Assets/logoraffa.webp'
import BtnContact from '../Components/BtnContact'
import arrowDown from '../Assets/arrow-down.svg'
import MenuPrimary from '../Components/MenuPrimary'


function Home() {

  return (
    <section id="home-section" className='flex-center flex-column flex__gap-30 background-image text-white'>
        <MenuPrimary/>
        <div className='flex-center flex-column flex__gap-10'>
            <div className='img img-600'>
                <img src={logo} alt='Raffa Fragoso' width="500" height="49" />
            </div>
            <h2 className='subtitle-main text-center'>Músico e Influencer Digital</h2>
        </div>
        <BtnContact text="Fale com a assessoria" />
        <div id='see-more' className='flex-center'>
          <span>Conheça mais sobre Raffa Fragoso</span>
          <div className='flex-center'>
            <img src={arrowDown} alt='flecha para baixo' width="25" height="25"/>
          </div>
        </div>
    </section>
  )
}

export default Home
